/* eslint-disable import/prefer-default-export */
import { useEffect, useState } from 'react';
import { ADDRESS_TYPE, INIT_SPECIFIC_TEXT_INPUT_ERROR } from './constants';

export const useAddressStates = ({ usedAddressTypes, initAddress = null, onClose }) => {
  const [addressType, setAddressType] = useState("home");
  const [addressTypes, setAddressTypes] = useState(ADDRESS_TYPE);
  const [streetAddress, setStreetAddress] = useState('');
  const [city, setCity] = useState('');
  const [locality, setLocality] = useState('CA');
  const [country, setCountry] = useState('US');
  const [postalCode, setPostalCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [specificTextInputError, setSpecificTextInputError] = useState(INIT_SPECIFIC_TEXT_INPUT_ERROR);

  useEffect(() => {
    if (initAddress) {
      setAddressType(initAddress?.addressType || "home");
      setStreetAddress(initAddress?.streetAddress || '');
      setCity(initAddress?.city || '');
      setLocality(initAddress?.locality || 'CA');
      setPostalCode(initAddress?.postalCode || '');
    } else {
      setAddressType(addressTypes[0]?.value || "home");
    }
  }, [initAddress, addressTypes]);

  useEffect(() => {
    const filteredAddressTypes = ADDRESS_TYPE.filter((type) => type.value === "other" || !usedAddressTypes.includes(type.value));

    setAddressTypes(filteredAddressTypes);
  }, [usedAddressTypes]);

  const onCloseHandlr = () => {
    setAddressType("home");
    setStreetAddress('');
    setCity('');
    setLocality('CA');
    setPostalCode('');
    setError(null);
    setSpecificTextInputError(INIT_SPECIFIC_TEXT_INPUT_ERROR);
    onClose();
  }

  return {
    addressType,
    addressTypes,
    streetAddress,
    city,
    locality,
    postalCode,
    country,
    isLoading,
    error,
    specificTextInputError,
    ADDRESS_TYPE,
    setAddressType,
    setAddressTypes,
    setStreetAddress,
    setCity,
    setLocality,
    setPostalCode,
    setCountry,
    setIsLoading,
    setError,
    setSpecificTextInputError,
    onCloseHandlr
  };
}
